module.exports = __webpack_public_path__ + "static/new-releases-4772131c0d5391149daca2330453a28e.jpg";